import { useQuery } from '@tanstack/react-query'
import { getCalendarEvents } from 'api/assignment/getCalendarEvents'
import { assignmentKeys } from './keys'

export const useCalendarEventsQuery = (
  request: Parameters<typeof getCalendarEvents>[0]
) => {
  return useQuery({
    queryKey: assignmentKeys.detail.calendarEvents(
      request.assignmentId,
      request.startDate,
      request.workStatus
    ),
    queryFn: () => getCalendarEvents(request),
  })
}
